import React from 'react';
import PropTypes from 'prop-types';

import { SORT_ORDERS } from '../../constants';

const SortList = ({ value, handleChange }) => {
  return (
    <div className="sortList">
      <div className="sortListItem">
        <div
          className={`sortListItemButton ${value === SORT_ORDERS.popularity ? 'active' : ''}`}
          onClick={() => handleChange(SORT_ORDERS.popularity)}
        >
          人気順
        </div>
      </div>
      <div className="sortListItem">
        <div
          className={`sortListItemButton ${value === SORT_ORDERS.priceAsc ? 'active' : ''}`}
          onClick={() => handleChange(SORT_ORDERS.priceAsc)}
        >
          安い順
        </div>
      </div>
      <div className="sortListItem">
        <div
          className={`sortListItemButton ${value === SORT_ORDERS.priceDesc ? 'active' : ''}`}
          onClick={() => handleChange(SORT_ORDERS.priceDesc)}
        >
          高い順
        </div>
      </div>
    </div>
  );

};

SortList.propTypes = {
  handleChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

export default SortList;
